import React, { PropsWithChildren } from 'react';
import { TrademarkProps, TrademarkProvider as TrademarkProviderContext } from '@cp/entities/trademark';
import { Trademark } from '@cp/ds/src/components/trademark';

const DefaultTrademark = (_: TrademarkProps) => <Trademark size={1.8} />;

export const TrademarkProvider = (props: PropsWithChildren) => (
  <TrademarkProviderContext value={DefaultTrademark}>{props.children}</TrademarkProviderContext>
);
